import { jsx as _jsx } from "react/jsx-runtime";
import { freddyTheme } from '@coolblue-development/freddy';
const imageDimensions = { width: 700, height: 700 };
export default function MediaGalleryImage({ item, imageSizes, isMainImage = false, BaseImage, }) {
    let currentSizes;
    if (typeof imageSizes === 'object') {
        currentSizes = Object.keys(imageSizes)
            .reverse()
            .map((key, index) => {
            if (index === Object.keys(imageSizes).length - 1) {
                return imageSizes[key];
            }
            return `(min-width: ${freddyTheme.breakpoint.values[key]}) ${imageSizes[key]}`;
        })
            .join(', ');
    }
    else {
        currentSizes = imageSizes;
    }
    return (_jsx(BaseImage, { alt: item.label, imageId: item.image.id, fileCollection: item.image.fileCollection, sizes: currentSizes, width: imageDimensions.width, height: imageDimensions.height, loading: isMainImage ? 'eager' : 'lazy', fetchPriority: isMainImage ? 'high' : 'low', fullHeight: true, fullWidth: true }));
}
//# sourceMappingURL=MediaGalleryImage.js.map